export const ACTIVE_ROLE_KEY = 'activeRole';

const CONFIRM_LOGOUT_DISABLED_LOCAL_STORAGE_KEY = 'confirmLogout';

export const setDisableConfirmLogout = (isDisabled = false) =>
  globalThis.localStorage.setItem(CONFIRM_LOGOUT_DISABLED_LOCAL_STORAGE_KEY, Boolean(isDisabled));

export const isConfirmLogoutDisabled = () =>
  Boolean(globalThis.localStorage.getItem(CONFIRM_LOGOUT_DISABLED_LOCAL_STORAGE_KEY)) === true;

export const getActiveRole = () => {
  const activeRoleRaw = globalThis.localStorage.getItem(ACTIVE_ROLE_KEY);
  return activeRoleRaw ? JSON.parse(activeRoleRaw) : null;
};

export const setActiveRole = role => {
  globalThis.localStorage.setItem(ACTIVE_ROLE_KEY, JSON.stringify(role));
};

export const clearActiveRole = () => {
  globalThis.localStorage.removeItem(ACTIVE_ROLE_KEY);
};

export const getTimeHistory = () => {
  const timeHistory = globalThis.localStorage.getItem('TIME_HISTORY');
  return timeHistory ? JSON.parse(timeHistory).reverse() : [];
};

export const setTimeHistory = dateRange => {
  const timeHistory = getTimeHistory();
  if (timeHistory.length < 10) {
    timeHistory.push(dateRange);
    globalThis.localStorage.setItem('TIME_HISTORY', JSON.stringify(timeHistory));
  } else {
    timeHistory.pop();
    timeHistory.push(dateRange);
    globalThis.localStorage.setItem('TIME_HISTORY', JSON.stringify(timeHistory));
  }
};
